















































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import CompanyAutocomplete from '@/components/CompanyAutocomplete.vue';
import {Company} from '@/interfaces/company.interface';
import {COUNTRIES, VALIDATION_RULES} from '@/helpers/helpers';
import {Country} from '@/interfaces/country.interface';

@Component({
  components: {CompanyAutocomplete}
})
export default class OrderFormCompanyFields extends Vue {
  company: Company = {};

  requiredTextFieldRules = VALIDATION_RULES.required;
  emailFieldRules = VALIDATION_RULES.email;

  @Prop() value!: Company;
  @Prop() companyNameLabel!: string;

  @Emit('input')
  private emitCompanyUpdate(company: Company) {
    return company;
  }

  @Watch('value', {deep: true})
  companyUpdated(company: Company) {
    this.company = company;
    this.emitCompanyUpdate(company);
  }

  @Watch('company')
  watchCompany(company: Company) {
    this.emitCompanyUpdate(company);
  }

  companySelectedFromDropdown(company: Company) {
    this.companyUpdated(company);
  }

  private getCompanyCountry(company: Company): Country {
    return COUNTRIES.find(c => c.name === company.country) || {name: 'this country', zipRequired: false, EU: false};
  }

  private isZipRequired(company: Company): boolean {
    const country = this.getCompanyCountry(company);
    return country && country.zipRequired;
  }

  getZipRules(company: Company): any[] {
    const country = this.getCompanyCountry(company);
    return this.isZipRequired(company) ? [(v: string) => !!v || `Zip is required for ${country.name}`] : [];
  }

  getZipLabel(company: Company): string {
    const asterisk = this.isZipRequired(company) ? ' *' : '';
    return `ZIP Code${asterisk}`;
  }

  get countries(): Country[] {
    return COUNTRIES;
  }

  isExistingCompany(company: Company): boolean {
    return !!company.uuid;
  }

  duplicateCompany(company: Company) {
    company.uuid = '';
  }
}
